$('.owl-one').owlCarousel({
    loop: true,
    autoplay: true,
    autoplayTimeout: 5000,
    smartSpeed: 450,
    margin: 10,
    nav: true,
    navText: ["<i class=\"icon prev\"></i>", "<i class=\"icon next\"></i>"],
    navClass: ['arrow-btn prev', 'arrow-btn next'],
    pagination: false,
    items: 1,
    dots: false,
    responsive: {
        0: {
            nav: false
        }
    }
});

$('.owl-two').owlCarousel({
    loop: false,
    dots: false,
    smartSpeed: 1000,
    nav: false,
    navText: ["<i class=\"icon prev\"></i>", "<i class=\"icon next\"></i>"],
    navClass: ['arrow-btn prev', 'arrow-btn next'],
    autoplay: false,
    pagination: false,
    // dotsClass:'carousel_toggle-wrp',
    // dotClass: 'carousel_toggle',
    // autoplayTimeout: 500000000,
    autoplayHoverPause: true,
    responsiveRefreshRate: 200,
    items: 3,

    responsive: {
        0: {
            items: 1,
            dots: true,
            nav: false,
            pagination: true,
            loop: true,
        },
        576: {
            dots: true,
            nav: false,
            pagination: true,
            items: 1,
            loop: true,
        },
        992: {
            items: 3,
            loop: false
        }
    }
});

$('.owl-three').owlCarousel({
    loop: true,
    dots: false,
    smartSpeed: 1000,
    nav: true,
    navText: ["<i class=\"icon prev\"></i>", "<i class=\"icon next\"></i>"],
    navClass: ['arrow-btn prev', 'arrow-btn next'],
    autoplay: true,
    autoplayTimeout: 500000,
    autoplayHoverPause: true,
    responsiveRefreshRate: 200,
    items: 7,
    margin: 20,
    responsiveClass: true,
    responsive: {
        0: {
            items: 3,
            nav: false,
            dots: true,
        },
        576: {
            items: 3,
            nav: false,
            dots: true,
        },
        600: {
            items: 3,
            nav: false
        },
        1000: {
            items: 7,
        }
    }
});

$(".owl-four").owlCarousel({
    loop: true,
    autoplay: true,
    autoplayTimeout: 5000,
    smartSpeed: 450,
    margin: 10,
    nav: true,
    navText: ["<i class=\"icon prev\"></i>", "<i class=\"icon next\"></i>"],
    navClass: ['arrow-btn prev', 'arrow-btn next'],
    pagination: false,
    thumbs: true,
    thumbImage: true,
    thumbsPrerendered: true,
    items: 1,
    dots: false,
});

$(".owl-carousel--nested").owlCarousel({
    dots: false,
    loop: true,
    rewind: true,
    margin: 20,
    items: 2
});

$('.owl-five').owlCarousel({
    loop: true,
    dots: false,
    smartSpeed: 1000,
    nav: true,
    navText: ["<i class=\"icon prev\"></i>", "<i class=\"icon next\"></i>"],
    navClass: ['arrow-btn prev', 'arrow-btn next'],
    autoplay: false,
    responsiveRefreshRate: 200,
    items: 1,
    margin: 35,
    responsiveClass: true,
    responsive: {
        0: {
            navClass: "",
            navText: "",
            dots: true,
        },
        576: {
            navClass: "",
            navText: "",
            dots: true
        },
        600: {
            navClass: "",
            navText: "",
            dots: true
        },
        1000: {
            navText: ["<i class=\"icon prev\"></i>", "<i class=\"icon next\"></i>"],
            navClass: ['arrow-btn prev', 'arrow-btn next']
        }
    }
});

$('.owl-fh-tariffs').owlCarousel({
    loop: false,
    dots: false,
    nav: false,
    autoplay: false,
    pagination: false,
    autoplayHoverPause: true,
    responsiveRefreshRate: 200,
    items: 2,
    margin: 50,

    responsive: {
        0: {
            items: 1,
            dots: true,
            pagination: true,
            loop: true,
        },
        576: {
            dots: true,
            pagination: true,
            items: 2,
            loop: true,
        },
        992: {
            items: 2,
            loop: false
        }
    }
});

$('.owl-bik-points').owlCarousel({
    loop: true,
    dots: true,
    nav: false,
    autoplay: false,
    pagination: false,
    autoplayHoverPause: true,
    responsiveRefreshRate: 200,
    items: 1,
    margin: 50,

    responsive: {
        0: {
            items: 1,
            dots: true,
            pagination: true,
            loop: true,
        },
        576: {
            dots: true,
            pagination: true,
            items: 1,
            loop: true,
        },
        992: {
            items: 1,
            loop: true
        }
    }
});



// WEBPACK FOOTER //
// src/js/libs/sliderCnf.js